import { useState } from "react";
import { MessageCircle, Mail, Phone, Check } from "lucide-react";
import { Container } from "../components/ui";
import { PageHeading } from "../ds/core";
import { useLocale } from "../i18n/useLocale";

const FIELD = "w-full rounded-xl border border-line bg-white px-4 py-3 text-[15px] text-ink outline-none transition-colors placeholder:text-ink-faint focus:border-primary";

export default function Contact() {
  const [sent, setSent] = useState(false);
  const { t } = useLocale();

  return (
    <>
      <PageHeading
        tone="light"
        eyebrow={t("contact:hero.eyebrow")}
        title={t("contact:hero.title")}
        intro={t("contact:hero.intro")}
      />

      <section className="bg-bg">
        <Container className="grid gap-12 py-16 md:grid-cols-[1fr_1.1fr]">
          <div className="flex flex-col gap-4">
            {[
              { icon: MessageCircle, t: t("contact:channel.whatsapp.title"), d: "+32 473 73 57 94", note: t("contact:channel.whatsapp.note") },
              { icon: Mail, t: t("contact:channel.email.title"), d: "hello@done-it.app", note: t("contact:channel.email.note") },
              { icon: Phone, t: t("contact:channel.phone.title"), d: "+32 473 73 57 94", note: t("contact:channel.phone.note") },
            ].map((c) => {
              const Icon = c.icon;
              return (
                <div key={c.t} className="flex items-start gap-4 rounded-2xl border border-line bg-bg-subtle p-4 md:p-6">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-primary shadow-sm">
                    <Icon size={20} strokeWidth={2} />
                  </span>
                  <div>
                    <h4 className="font-display text-[16px] font-semibold text-ink">{c.t}</h4>
                    <div className="mt-0.5 text-[15px] font-medium text-ink">{c.d}</div>
                    <div className="mt-0.5 text-[13px] text-ink-faint">{c.note}</div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="rounded-3xl border border-line bg-white p-4 md:p-8">
            {sent ? (
              <div className="flex h-full flex-col items-center justify-center gap-3 py-10 text-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-success-soft text-success">
                  <Check size={24} strokeWidth={2.4} />
                </span>
                <h3 className="font-display text-xl font-semibold text-ink">{t("contact:sent.title")}</h3>
                <p className="max-w-xs text-[14px] leading-relaxed text-ink-soft">{t("contact:sent.body")}</p>
              </div>
            ) : (
              <form className="flex flex-col gap-4" onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
                <h3 className="font-display text-xl font-semibold text-ink">{t("contact:form.title")}</h3>
                <div className="grid gap-4 sm:grid-cols-2">
                  <input className={FIELD} placeholder={t("contact:form.name")} required />
                  <input className={FIELD} placeholder={t("contact:form.company")} />
                </div>
                <input className={FIELD} type="email" placeholder={t("contact:form.email")} required />
                <textarea className={`${FIELD} min-h-[120px] resize-none`} placeholder={t("contact:form.message")} />
                <button type="submit" className="mt-1 inline-flex items-center justify-center rounded-xl bg-primary px-6 py-3.5 font-display text-[15px] font-semibold text-white transition-colors hover:bg-primary-hover">
                  {t("contact:form.submit")}
                </button>
              </form>
            )}
          </div>
        </Container>
      </section>
    </>
  );
}

